export default __webpack_public_path__ + "static/media/expense.578a7471.png";